import { useState, useCallback } from 'react'

import { useApiCacheStore } from 'store/apiCacheStore'
import { getAPI } from 'utils/getAPI'
// import { useCurrentStatusStore } from 'store/currentStatusStore'

import type { Groups, ResponseResult } from 'api-client'

export const useTypecode = () => {
  const [typeCode, setTypeCode] = useState<Groups[]>([])
  const [result, setResult] = useState<ResponseResult | undefined>(undefined)
  const [isLoading, setIsLoading] = useState(false)
  
  // const { setCurrentStatuses } = useCurrentStatusStore()
  const { callApiWithCache } = useApiCacheStore()

  const fetchTypeCode = useCallback(async () => {
    setIsLoading(true)

    try {
      const response = await callApiWithCache(
        '/typecode',
        {}, // no params for typecode
        async () => {
          // Actual API call
          const api = await getAPI()
          if (!api) throw new Error('API initialization failed')
          return api.getSysTypecodeTypecodeGet()
        },
        null
      )

      setTypeCode(response.data)
      setResult(response.result)
      // setCurrentStatuses(response.result.systemInfo?.sysCurrentStatus)
    } catch (error) {
      setResult({
        status: 'error',
        message: `タイプコード取得でエラーが発生しました。`,
        systemDate: null,
        pageNo: 0,
        systemInfo: null,
      })
    } finally {
      setIsLoading(false)
    }
  }, [callApiWithCache])

  return {
    typeCode,
    result,
    fetchTypeCode,
    isLoading,
  }
}
